<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-row>
                        <v-col cols="12">
                            <v-row>
                                <v-col cols="12">
                                    <h1 class="text-center">Alerts</h1>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-data-table
                                        :headers="headers"
                                        :items="alerts"
                                        :loading="loading"
                                        hide-default-footer
                                    >
                                        <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                                        <template slot="item" slot-scope="props">
                                            <tr :data-id="props.item.ID">
                                                <td>{{props.item.AlertName}}</td>
                                                <td>{{props.item.Email}}</td>
                                                <td v-if="props.item.Active"><v-icon color="success">check</v-icon></td>
                                                <td v-else><v-icon color="error">close</v-icon></td>
                                                <td>
                                                    <v-btn
                                                        v-if="canEdit(props.item)"
                                                        color="warning"
                                                        block
                                                        @click="editAlert(props.item)"
                                                    >
                                                        Edit
                                                    </v-btn>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-if="!loading" slot="no-data">
                                            <v-alert v-if="loadError" outlined :value="true" color="error" icon="error">
                                                {{loadError}}
                                            </v-alert>
                                            <v-alert v-if="!loadError" outlined :value="true" type="info">
                                                No results found
                                            </v-alert>
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-dialog v-model="showEditDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                            <v-card>
                                <v-toolbar dark color="primary">
                                    <v-btn icon dark :disabled="saving" @click="cancelEditAlert">
                                        <v-icon large>close</v-icon>
                                    </v-btn>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-title>Edit Alert</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        
                                    </v-toolbar-items>
                                </v-toolbar>
                                <v-form @submit.prevent ref="editForm" v-model="editAlertValid">
                                    <v-row class="dialog-content">
                                        <v-col cols="12" md="6" offset-md="3">
                                            <v-row >
                                                <v-col cols="12">
                                                    <v-text-field
                                                        clearable
                                                        counter="100"
                                                        maxlength="100"
                                                        v-model="editedAlert.Email"
                                                        :rules="[rules.email, requiredIfActive]"
                                                        label="Alert Recipient Email">
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <v-checkbox label="Active" v-model="editedAlert.Active"></v-checkbox>
                                                </v-col>
                                            </v-row>
                                            <v-row  class="dialog-action-buttons">
                                                <v-col cols="12" sm="6">
                                                    <v-btn block color="error" :disabled="saving" @click="cancelEditAlert">Cancel</v-btn>
                                                </v-col>
                                                <v-col cols="12" sm="6">
                                                    <v-btn block color="success" :disabled="!editAlertValid" :loading="saving" @click="saveEditedAlert">Save</v-btn>
                                                </v-col>
                                                <v-col cols="12" v-if="saveError">
                                                    <v-alert text type="error">{{ saveError }}</v-alert>
                                                </v-col>
                                            </v-row>                            
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<style>
    
</style>

<script>
import validationRules from "../../helpers/validationrules";
import * as auth from '@/services/auth';
import permissions from 'comunet-btg-utah-repository-shared/permissions'

export default {
    components: {
    },
    props: [
        
    ],
    data() {
        return {
            auth: auth,
            permissions: permissions,
            editedAlert: {
                
            },
            showEditDialog: false,
            editAlertValid: false,
            rules: validationRules.rules,
            headers: [
                {
                    text: "Alert",
                    value: "Alert"
                },
                {
                    text: "Email",
                    value: "Email"
                },
                {
                    text: "Active",
                    value: "Active"
                },
                {
                    text: "", // edit button
                    sortable: false
                }
            ]
        };
    },
    computed: {
        loading() {
            return this.$store.state.alertStore.loading;
        },
        loadError() {
            return this.$store.state.alertStore.loadError;
        },
        saving() {
            return this.$store.state.alertStore.saving;
        },
        saveError() {
            return this.$store.state.alertStore.saveError;
        },
        alerts() {
            return this.$store.state.alertStore.alerts;
        }
    },
    methods: {
        requiredIfActive(value) {
            if (this.editedAlert && this.editedAlert.Active) {
                // we need an email address if the alert is active
                return this.rules.required(value);
            }

            return true;
        },
        loadAlerts() {
            this.$store.dispatch("alertStore/load");
        },
        editAlert(item) {
            this.editedAlert = Object.assign({
                
            }, item);

            this.editedAlert;

            this.showEditDialog = true;

            // show which fields are mandatory when opening the edit form
            this.$nextTick(() => this.$refs.editForm.validate());
        },
        cancelEditAlert() {
            this.showEditDialog = false;
            this.editedAlert = {
                
            };
        },
        saveEditedAlert() {
            var that = this;

            this.$store.dispatch("alertStore/save", {
                alert: this.editedAlert,
                finally: function() {
                    if (that.$store.state.alertStore.saveError) {
                        // do not close the dialog
                        // display the error
                    }
                    else {
                        // close the dialog
                        that.cancelEditAlert();
                    }
                }
            });
        },
        canEdit() {
            // don't show the edit button if we are a read only user
            if (auth.currentUserIsReadOnly()) {
                return false;
            }

            return true;
        }
    },
    created() {
        this.loadAlerts();
    },
    watch: {
        editedAlert: {
            handler() {
                // whenever the object changes, retrigger the validation
                // we need this because the validation of email depends on the value of active
                this.$refs.editForm.validate();
            },
            deep: true
        }
    }
};
</script>